import { useSidebar } from "../../context/SidebarContext";

const HamburgerIcon = () => (
	<svg
		className="h-6 w-6"
		fill="none"
		viewBox="0 0 24 24"
		strokeWidth={1.8}
		stroke="currentColor"
	>
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M3.75 6.75h16.5M3.75 12h16.5M3.75 17.25h16.5"
		/>
	</svg>
);

const BUTTON_CLS = "p-2 rounded-md text-secondary hover:bg-gray-100 transition-colors";

/**
 * Hamburger button that lives in the page header (outside the drawer). Below
 * lg it opens the nav drawer; from lg up it collapses/expands the sidebar into
 * an icon-only rail. Two buttons, one shown per breakpoint, so neither needs
 * to know the viewport width.
 */
const SidebarToggle = () => {
	const { toggleCollapsed, mobileOpen, openMobile } = useSidebar();
	return (
		<>
			<button
				type="button"
				onClick={openMobile}
				aria-label="Open menu"
				aria-expanded={mobileOpen}
				className={`${BUTTON_CLS} lg:hidden`}
			>
				<HamburgerIcon />
			</button>
			<button
				type="button"
				onClick={toggleCollapsed}
				aria-label="Toggle sidebar"
				className={`${BUTTON_CLS} hidden lg:inline-flex`}
			>
				<HamburgerIcon />
			</button>
		</>
	);
};

export default SidebarToggle;
